<template>
  <b-navbar-nav class="mr-auto">
    <b-nav-item-dropdown right v-if="isUserLoggedIn">
      <!-- Using 'button-content' slot -->
      <template v-slot:button-content>
        <em>({{ user.mobile }})</em>
      </template>
      <b-dropdown-item href="#">Profile</b-dropdown-item>
      <b-dropdown-item href="#" @click="logout">{{ logoutLabel }}</b-dropdown-item>
    </b-nav-item-dropdown>

    <b-nav-item
      v-if="!isUserLoggedIn"
      href="#"
      v-b-modal="'register-modal'"
      @click="showSignupModal"
    >
      <i class="fas fa-user-plus ml-1"></i>
      <span>{{ signupLabel }}</span>
    </b-nav-item>
    <b-nav-item v-if="!isUserLoggedIn" href="#" v-b-modal="'login-modal'" @click="showLoginModal">
      <i class="fas fa-user ml-1"></i>
      <span>{{ loginLabel }}</span>
    </b-nav-item>

    <b-nav-item @click="showCheckoutModal" v-b-modal="'checkout-modal'" class="cart">
      <span class="icon">
        <i class="fa fa-shopping-cart ml-1"></i>
      </span>
      <b-badge variant="danger" class="cart-counter">{{ numProductsAdded }}</b-badge>
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "menu-component",
  data() {
    return {
      wishlistLabel: "علاقه مندی",
      logoutLabel: "خروج",
      loginLabel: "ورود",
      signupLabel: "ثبت نام",
    };
  },

  computed: {
    ...mapGetters({
      user: "user",
      isUserLoggedIn: "isUserLoggedIn",
    }),

    numProductsAdded() {
      return this.$store.getters.cartItems.reduce(
        (a, b) => a + b.quantity,
        0
      );
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        // redirect to homepage
        this.$router.push({ name: "homepage-component" });
      });
    },
    showLoginModal() {
      this.$store.commit("showLoginModal", true);
    },
    showSignupModal() {
      this.$store.commit("showSignupModal", true);
    },
    showCheckoutModal() {
      this.$store.commit("showCheckoutModal", true);
    },
  },
};
</script>


<style lang='scss'>
.cart {
  position: relative;
}
.cart .icon {
  font-size: 1.2rem;
}
.cart-counter {
  position: absolute;
  left: 25px;
  top: -1px;
}
</style>

